
import React, { useContext, useEffect, useState } from "react";
import Cookies from 'universal-cookie';
import { MiFooter } from "../../components/footer/MiFooter";
import Header from "../../components/headers/Header";
import HeaderHome from "../../components/headerHome/HeaderHome";
import EmpresasBodyMarketPlace from "../../components/marketPlace/EmpresasBodyMarketPlace";
import EmpresasCargadas from "../../components/marketPlace/EmpresasCargadas";
import { UsuarioContext } from '../../contexts/UsuarioContext';
import { useSessionStore } from "../../hooks/useSessionStore";
import "./Marketplace.css";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Helmet } from "react-helmet";

import { MenuLateralAB } from "../../components/menuLateralAA/MenuLateralAB";
import { animateScroll as scroll } from 'react-scroll';
import DesktopSearchPanel from "../../components/marketPlace/DesktopSearchPanel";
import { MenuEmpresas } from "../../components/marketPlace/MenuEmpresas";
import { BannerMarket } from "../../components/marketPlace/BannerMarket";
import axios from 'axios';
import { Mapas } from "../../components/marketPlace/Mapas";
import { BuscadorNombres } from "../../components/marketPlace/BuscadorNombres";
import { Buscador } from "../../components/marketPlace/Buscador";
import { useLocation } from "react-router-dom";

import { ModalMapa } from "../../components/marketPlace/ModalMapa";

import Filtro from "../../components/Filtro/filtro";
import Sorter from "../../components/Filtro/sorter";

export const Marketplace = () => {

  const LIMITE = 9;

  const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
  /* Using the useSessionStore hook to get the UsuarioContext from the session storage. */
  /* Destructuring the context. */
  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
  //const [Usuario, setUsuario] = useSessionStore({ Usuario: "Usuario" });
  const [autLocalidades, setAutLocalidades] = useState(false);
  ;

  /* Declaring a state variable called `MenuNoHayEmpresa` and initializing it with the value `false`.
  It also declares a function called `setMenuNoHayEmpresa` that can be used to update the value of
  `MenuNoHayEmpresa`. This state variable is likely used to control the display of a menu or message
  when there are no companies available in the marketplace. */
  const [MenuNoHayEmpresa, setMenuNoHayEmpresa] = useState(false);

	const [ btnSelected, setBtnSelected ] = useState();

  // El estado Empresas almacena la lista de empresas.
  const [Empresas, setEmpresas] = useState([]);
  const [empresasCargadas, setEmpresasCargadas] = useState([])

  const [abrirFiltro, setAbrirFiltro] = useState(false)
  const [sortBy, setSortBy] = useState('default')
  const [listaRating, setListaRating] = useState([])
  const [ distance, setDistance ] = useState(25)
  const [ prevLimite, setPrevLimite ] = useState(9)
  const [ limite, setLimite ] = useState(LIMITE)
  const [ buscarNombre, setBuscarNombre ] = useState()
  const [ buscarCategoria, setBuscarCategoria ] = useState()
  const [ categoriaSeleccionada, setCategoriaSeleccionada ] = useState()
  const [ buscarLocalidad, setBuscarLocalidad ] = useState(0)
  const [ buscarProvincia, setBuscarProvincia ] = useState()

  const [Categorias, setCategorias] = useState([]);

  const [Mapa, setMapa] = useState(false);

  // El estado FiltroCategorias almacena el ID de la categoría a filtrar.
  const [FiltroCategorias, setFiltroCategorias] = useState();

  const [ModalUbiacion, setModalUbiacion] = useState(false);
  const [SeleccionUbicacion, setSeleccionUbicacion] = useState(false);
  const [Ubicacion, setUbicacion] = useState({
      lat: 40.41831,
      lng: -3.70275,
  });
  const [RadioUbicacion, setRadioUbicacion] = useState(0);

  const [zoom, setZoom] = useState(9);

  const [loading, setLoading] = useState();
  const [loadingCargadas, setLoadingCargadas] = useState();

  /**
   * Recupera los detalles de una empresa a partir de su ID.
   * @param {number} id - El ID de la empresa a buscar.
   * @returns {Promise<Object>} Una promesa que resuelve con un objeto que contiene los detalles de la empresa.
   */
  const getEmpresa = async (id) => {
    try {
      const response = await axios.get(window.ipdirection + "prestadorServiciosCliente/" + id + "/");
      const empresa = response.data;
      // Recupera la imagen de perfil de la empresa y crea una URL para ella.
      let imagenURL = "";
      try {
        const imagenResponse = await axios.get(window.ipdirection + `imagenPerfilEmpresaCliente/${empresa.id}/`, {
          responseType: "blob"
        });
        imagenURL = URL.createObjectURL(imagenResponse.data);
        return ({ ...empresa, img: imagenURL });
      } catch (error) {
        imagenURL = window.ipdirection + "logoCuidatia5.68c5966743354987255d.png";
        return ({ ...empresa, img: imagenURL });
      }
      // Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
    } catch (error) {
      console.log(error);
    }
  };


  /**
 * Recupera una lista de empresas a partir de una categoría dada.
 * @param {number} id - El ID de la categoría a buscar.
 * @returns {Promise<void>} Una promesa que resuelve cuando la lista de empresas ha sido recuperada.
 */
  const seleccionCategorias = async (id) => {
    setCategoriaSeleccionada(id)
    setBtnSelected(id)
    console.log(buscarCategoria)
    let lista = [];
    setEmpresas([]);
    // Verifica si el ID de la categoría es válido.
    if (id === 999999) {
      try {
        // Recorre la lista de empresas y recupera sus detalles.
        for (let rspt of Usuario.recomendaciones) {
          try {
            const resultado = await getEmpresa(rspt);
            if(resultado!==undefined){
              lista.push(resultado);
            }
          } catch (error) {
            console.log(error);
          }
        }
        console.log(lista)
        // Actualiza el estado de la lista de empresas.
        setEmpresas(lista);
      } catch (error) {
        // Si se produce un error al recuperar la lista de empresas, se llama a la función getEmpresas().
        setMenuNoHayEmpresa(true)
        getEmpresas();
        console.log(error);
      }
    } else if (id !== 0) {
      try {
        // Recupera la lista de empresas asociadas a la categoría.
    //     const response = await axios({
    //       method: "get",
    //       url: window.ipdirection + "categoriaEmpresaCliente/?categoria_id=" + id
    //     });
    //     // Recorre la lista de empresas y recupera sus detalles.
    //     for (let rspt of response.data) {
    //       console.log('Respuesta ', rspt)
    //       try {
    //         const resultado = await getEmpresa(rspt.empresa_id);
    //         lista.push(resultado);
    //       } catch (error) {
    //         console.log(error);
    //       }
    //     }
    //     // Actualiza el estado de la lista de empresas.
    //     setEmpresas(lista);
    //   } catch (error) {
    //     // Si se produce un error al recuperar la lista de empresas, se llama a la función getEmpresas().
    //     setMenuNoHayEmpresa(true)
    //     getEmpresas();
    //     console.log(error);
    //   }
    // } else {
    //   // Si el ID de la categoría es 0, se llama a la función getEmpresas().
    //   getEmpresas();

      // const response = await axios({
      //     method: "get",
      //     url: window.ipdirection + "busquedaAvanzada/?categoria_id=" + id ,
      //   });
        const response = await axios.get(window.ipdirection + "busquedaAvanzada/?nombreEmpresa="+buscarNombre+"&categoria_id="+id+"&localidad_id="+buscarLocalidad+"&provincia_id="+buscarProvincia)
        const empresas = response.data;

        // Crea una promesa por cada empresa para recuperar su imagen de perfil y crear una URL.
        const empresasConImagenes = await Promise.all(
            empresas.map(async empresa => {
                try {

                    const imagenResponse = await axios.get(window.ipdirection + `imagenPerfilEmpresaCliente/${empresa.id}/`, {
                        responseType: "blob"
                    });
                    const imagenURL = URL.createObjectURL(imagenResponse.data);
                    // Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
                    return { ...empresa, img: imagenURL };
                } catch (error) {
                    return { ...empresa, img: "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images" };
                };
            })
        );

        // Actualiza el estado Empresas con la lista de empresas que incluyen sus imágenes de perfil.
        // getEmpresas_preRegistradas()
        setEmpresas(empresasConImagenes);
      } catch (error) {
        //console.log(error);
      };
    }
  }

  useEffect(() => {
    // setBuscarCategoria(buscarCategoria)
    setBuscarCategoria(categoriaSeleccionada)
  },[categoriaSeleccionada])

  // useEffect(() => {
  //   // setBuscarCategoria(buscarCategoria)
  //   if(categoriaSeleccionada != ''){
  //     getEmpresas_preRegistradas()
  //     setCategoriaSeleccionada('')
  //   }
  // },[buscarCategoria])
    



  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }
    if (autLocalidades) {
      setAutLocalidades(false);
    }

  }

  /* A hook that is executed when the component is mounted. */
  const [OverleyModal, setOverleyModal] = useState("true");

  /* A hook that is executed when the component is mounted. */
  useEffect(() => {
    const cookiePrivacidad = new Cookies();
    (cookiePrivacidad.get("estado") === undefined) ? setOverleyModal("false") : setOverleyModal(cookiePrivacidad.get("estado"))
  }, [])

  /**
   * It sets the cookie to the value of the parameter cerrar.
   */
  const cerrarPrivacidad = (cerrar) => {
    const cookiePrivacidad = new Cookies();
    console.log(OverleyModal)
    cookiePrivacidad.set("estado", true)
    setOverleyModal(true)
  }



  const getImagenEmpresa = (id, lista, empresa) => {
    axios({
      method: "get",
      url: window.ipdirection + "imagenPerfilEmpresaCliente/" + id + "/",
      responseType: 'blob'
    }).then(response => {
      let newArray = [...Empresas]
      newArray.push({ ...empresa, img: URL.createObjectURL(response.data) })
      setEmpresas(newArray)
    });
  }

  /**
 * Recupera la lista de empresas y sus imágenes de perfil.
 * Actualiza el estado Empresas con la lista de empresas que incluyen sus imágenes de perfil.
 * @returns {Promise<void>}
 */
  const getEmpresas = async () => {
    try {
      // Recupera la lista de empresas.
      const response = await axios.get(window.ipdirection + "prestadorServiciosCliente/");
      const empresas = response.data;

      // Crea una promesa por cada empresa para recuperar su imagen de perfil y crear una URL.
      const empresasConImagenes = await Promise.all(
        empresas.map(async empresa => {
          try {

            const imagenResponse = await axios.get(window.ipdirection + `imagenPerfilEmpresaCliente/${empresa.id}/`, {
              responseType: "blob"
            });
            const imagenURL = URL.createObjectURL(imagenResponse.data);
            // Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
            return { ...empresa, img: imagenURL };
          } catch (error) {
            return { ...empresa, img: "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images" };
          }
        })
      );

      // Actualiza el estado Empresas con la lista de empresas que incluyen sus imágenes de perfil.
      setEmpresas(empresasConImagenes);
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //   // Llama a la función para cargar empresas cuando se monte el componente o cambien las dependencias relevantes.
  //   const fetchEmpresas = async () => {
  //     setLoading(true); // Activa el estado de carga antes de iniciar la petición.
  //     await getEmpresas_preRegistradas();
  //     await getEmpresas();
  //     setLoading(false); // Desactiva el estado de carga cuando termina la petición.
  //   };

  //   fetchEmpresas();
  // }, [buscarNombre, buscarCategoria, buscarLocalidad, buscarProvincia, limite]);

  const {search} = useLocation();
  const query = new URLSearchParams(search)

  const getEmpresas_preRegistradas = async () => {
    const q = query.get('q');
		const lugar = query.get('lugar')
		const categoria = query.get('categoria')
    
    const response = await axios({
      method: 'get',
      url:
        window.ipdirection +
        'BusquedaAvanzada_PreRegistrados/?nombreEmpresa=' +
        q+
        '&categoria_id=' +
        categoria +
        '&categoria_nombre=' +
        q+
        '&localidad_id=' +
        lugar +
        '&d='+ distance +
        "&limite="+limite+
        "&prevLimite="+prevLimite,
    });
    setPrevLimite(limite);
    const empresasCargadasList = response.data
    const empresasCargadasConImagenes = await Promise.all(
      empresasCargadasList.map(async empresa => {

        try {
          const imagenResponse = await axios.get(window.ipdirection + `imagenPerfilEmpresaPreregistrada/${empresa.id}/`, {
            responseType: "blob"
          });
          const imagenURL = URL.createObjectURL(imagenResponse.data);
          // Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
          return { ...empresa, img: imagenURL };
        } catch (error) {
          // const imagenDefault = window.ipdirection + "logoCuidatia5.68c5966743354987255d.png";
          const imagenDefault = "https://cdn-icons-png.flaticon.com/512/883/883360.png";

          return { ...empresa, img: imagenDefault};
        }
      })
    );
    setEmpresasCargadas((prevEmpresas) => [...prevEmpresas, ...empresasCargadasConImagenes])
  }

  // Ejecuta la función getEmpresas una vez, al cargar la página.
  // useEffect(() => {
  //   scroll.scrollToTop();
  //   getEmpresas();
  //   getEmpresas_preRegistradas();
  // }, []);

  // El estado MenuLateralAux indica si el menú lateral está abierto o cerrado.
  const [MenuLateralAux, setMenuLateralAux] = useState();

  /**
   * Cambia el estado MenuLateralAux para abrir o cerrar el menú lateral.
   */
  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  };

  // const categoria_empresa = (Empresas) => {
  //   Empresas.map((empresa)=>{
      
  //   })
	// }

  // useEffect(()=>{
  //   categoria_empresa(empresasCargadas)
  // },[empresasCargadas])

  const handleSort = (event) =>{
		setSortBy(event.target.value)
	}

  return (<>
    <Helmet>
      <link rel="canonical" href="https://www.cuidatia.org/busqueda" />
    </Helmet>
    <Modal centered={true} isOpen={MenuNoHayEmpresa}>
      <ModalHeader>
        <div className='titulo-modal'>
          No hay empresas en esta categoría
        </div>
      </ModalHeader>
      <ModalBody>
        <div className='descripcion-servicio descripcion-modal'>
          Todavia no hay empresas asociadas a esta categoría.
        </div>
      </ModalBody>
      <ModalFooter>
        <div className='centradorRight'>
          <div className='button' onClick={() => setMenuNoHayEmpresa(false)}><b>Aceptar</b></div>
        </div>
      </ModalFooter>
    </Modal>
    <Modal centered={true} isOpen={abrirFiltro}>
      <Filtro distance={distance} setDistance={setDistance} listaRating={listaRating} setListaRating={setListaRating} abrirFiltro={abrirFiltro} setAbrirFiltro= {setAbrirFiltro}/>
    </Modal>
    <MenuLateralAB seleccionado={13} MenuLateralAux={MenuLateralAux} chageMenuLateralAux={chageMenuLateralAux} />
    <div onClick={closeMenu} Id="Market">
      {
        OverleyModal === "false" && <Modal
          cerrarPrivacidad={cerrarPrivacidad}
        />
      }
      <div className="headerPagina"  >
        <HeaderHome
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="body" Id="bodyMarket" >
        {/* <BannerMarket /> */}
        {/*
                  <DesktopSearchPanel
                    autLocalidades={autLocalidades}
                    setAutLocalidades={setAutLocalidades}
                  />
          */}
        {/* <BuscadorNombres
          Empresas={Empresas}
          setEmpresas={setEmpresas}
          mapa={Mapa}
          setMapa={setMapa}
          setModalUbiacion={setModalUbiacion}
          setEmpresasCargadas={setEmpresasCargadas}
          getEmpresas_preRegistradas={getEmpresas_preRegistradas}
          setBuscarNombre={setBuscarNombre}
          setBuscarCategoria={setBuscarCategoria}
          setBuscarLocalidad={setBuscarLocalidad}
          setBuscarProvincia={setBuscarProvincia}
          limite={limite}
        /> */}
        <Buscador
          Empresas={Empresas}
          setEmpresas={setEmpresas}
          mapa={Mapa}
          setMapa={setMapa}
          setModalUbiacion={setModalUbiacion}
          empresasCargadas={empresasCargadas}
          setEmpresasCargadas={setEmpresasCargadas}
          getEmpresas_preRegistradas={getEmpresas_preRegistradas}
          setBuscarNombre={setBuscarNombre}
          setBuscarCategoria={setBuscarCategoria}
          setBuscarLocalidad={setBuscarLocalidad}
          setBuscarProvincia={setBuscarProvincia}
          limite={limite}
          prevLimites={prevLimite}
          distance={distance}
          listaRating={listaRating}
          sortBy={sortBy}
          setLoading={setLoading}
          setLoadingCargadas={setLoadingCargadas}
        />
        {/* <MenuEmpresas
          btnSelected={btnSelected}
          seleccionCategorias={seleccionCategorias}
          setBuscarCategoria={setBuscarCategoria}
        /> */}

        <div className="filtro-superior">
          <select className="select-filtro" onChange={handleSort}>
            <option value="default" selected disabled>Ordenar por</option>
            <option value="puntuacion">Valoración</option>
            <option value="distancia">Distancia</option>
          </select>
          <div className="boton-filtro" onClick={()=>{setAbrirFiltro(true)}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line></svg>
            <div>Filtrar</div>
          </div>
        </div>

        <ModalMapa ModalUbiacion={ModalUbiacion} setModalUbiacion={setModalUbiacion} Ubicacion={Ubicacion} setUbicacion={setUbicacion} RadioUbicacion={RadioUbicacion} setRadioUbicacion={setRadioUbicacion} empresas={Empresas} zoom={zoom} />
        <div className="empresas-wrapper">
          <div className="empresas-content">
            <EmpresasBodyMarketPlace className="groupEmpresas" ident="1"
              Empresas={Empresas}
              setEmpresas={setEmpresas}
              categorias={Categorias}
              buscarNombre={buscarNombre}
              listaRating={listaRating}
              sortBy={sortBy}
              loading={loading}
              />

            <EmpresasCargadas 
              empresasCargadas={empresasCargadas} 
              limite={limite} 
              setLimite={setLimite} 
              setPrevLimite={setPrevLimite}
              getEmpresas_preRegistradas={getEmpresas_preRegistradas}
              buscarNombre={buscarNombre}
              buscarCategoria={buscarCategoria}
              buscarLocalidad={buscarLocalidad}
              buscarProvincia={buscarProvincia}
              categorias={Categorias}
              loading={loadingCargadas}
              />
          </div>
          <div className="empresas-filter">
            <Sorter sortBy={sortBy} setSortBy={setSortBy}/>
            <Filtro distance={distance} setDistance={setDistance} listaRating={listaRating} setListaRating={setListaRating}/>
          </div>
        </div>
        
        <Mapas />
        
      </div>
      <div className="fooderMarket">
        <MiFooter />
      </div>
    </div>
  </>
  );
}

export default Marketplace;